import React from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import EditCategoryForm from '../../../component/categoryComps/editCategoryForm/EditCategoryForm';

const EditCategory = () => {


  return (
    <div>
      <InformationHeader mainpage="Dashboard" prevpage="Categories"  pagename="Edit Category" buttonText="Update category"/>
      <EditCategoryForm />
    </div>
  );
};

export default EditCategory;
